'use strict';

var React = require('react');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var SvgIcon = require('material-ui/lib/svg-icon');

var FolderDownload = React.createClass({
  displayName: 'FolderDownload',

  mixins: [PureRenderMixin],

  render: function render() {
    return React.createElement(
      SvgIcon,
      this.props,
      React.createElement('path', { d: 'M20,6A2,2 0 0,1 22,8V18A2,2 0 0,1 20,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4H10L12,6H20M19.25,13H16V9H14V13H10.75L15,17.25' })
    );
  }

});

module.exports = FolderDownload;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-mdi/icons/folder-download.js
// module id = 809
// module chunks = 0